import axios from "axios";
import axiosInstance from "./index";

export const createEnquiry = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/enquiry`, data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const createEnquiryByItineraryId = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/enquiry/create-from-itinerary`, data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const closeEnquiry = async (id: any) => {
  try {
    const response = await axiosInstance.put(`/enquiry/${id}/close`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const updatePrefrences = async (data: any, id: string) => {
  try {
    const response = await axiosInstance.post(`/enquiry/${id}/preference`, data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const searchItinerary = async (data: any) => {
  try {
    let url = `/itinerary`;

    if (data?.startDate) {
      url += `&start_date=${encodeURIComponent(data?.startDate)}&end_date=${encodeURIComponent(
        data?.endDate
      )}`;
    }
    if (data?.departureId) {
      url += `&origin_port_id=${encodeURIComponent(data?.departureId)}`;
    }
    if (data?.destinationId) {
      url += `&destination_port_id=${encodeURIComponent(data?.destinationId)}`;
    }
    if (data?.tripType) {
      url += `&trip_type=${encodeURIComponent(data?.tripType)}`;
    }
    if (data?.shipId) {
      url += `&ship_id=${encodeURIComponent(data?.shipId)}`;
    }
    if (data?.nightCount && data?.nightCount?.length) {
      url += `&nightCount=${encodeURIComponent(data?.nightCount.join(","))}`;
    }
    url += `&page=1&limit=500`;

    const replacedUrl = url.replace("&", '?')
    const response = await axiosInstance.get(replacedUrl);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getItineraryById = async (id: any) => {
  try {
    const { data } = await axiosInstance.get(`/itinerary/details/${id}`);
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const previewItinerary = async (data: any) => {
  try {
    const response = await axiosInstance.get(`/itinerary/preview?ids=${data?.join(",")}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const manageItineraryEnquiry = async (id: string, data: any) => {
  try {
    const response = await axiosInstance.post(`/enquiry/${id}/itinerary`, data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const sendItineraryEmail = async (enquiryId: string) => {
  try {
    const response = await axiosInstance.get(`/enquiry/${enquiryId}/send`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getItinerarybyEnquiryId = async (enquiryId: string) => {
  try {
    const response = await axiosInstance.get(`/itinerary/enquiry/${enquiryId}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getCommonOption = async () => {
  try {
    const response = await axiosInstance.get(`/quotation/common-options`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getAvailableRooms = async (id: string[], preferenceArr: string[], specialPricing: boolean, upgradeOffer: boolean) => {
  try {
    const baseURL = `/itinerary/rooms-availability`;
    const params = new URLSearchParams({
      ids: id.join(","),
      special_pricing: String(specialPricing),
      upgrade_offer: String(upgradeOffer)
    });

    if (!!preferenceArr.length) {
      params.append("preference", preferenceArr.join(","));
    }

    const response = await axiosInstance.get(`${baseURL}?${params.toString()}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getSpecialAddon = async () => {
  try {
    const response = await axiosInstance.get(`/quotation/special-requests`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getPublicItineraryDetails = async (itineraryId: string) => {
  try {
    const response = await axiosInstance.get(`/public/itinerary/${itineraryId}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getDashboardCount = async () => {
  try {
    const response = await axiosInstance.get(`/staff/staff-summary`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};
